export const RadioGroupWidgetId = 'RadioGroupWidget';

export enum RadioGroupWidgetAttributes {
  RADIOS = 'radios',
  DEFAULT_SELECTED_RADIO = 'defaultSelectedRadio',
}
